import { forwardRef } from 'react';
import { Button, ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const ErrorButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => (
    <Button
      ref={ref}
      variant="destructive"
      className={cn(
        'bg-destructive/40 border border-destructive/40 hover:bg-destructive/60',
        className
      )}
      {...props}
    />
  )
);
ErrorButton.displayName = 'ErrorButton';

export default ErrorButton;
